import API from '@services/API';
import { AXIOS as axios } from '@services/API';

const PendenciaService = {
  filtrar: async (processo, filters) => await API.filters(`${processo}/pendencias`, filters),
  listar: async (processo) => await API.list(`${processo}/pendencias`),
  listarUm: async (processo, id) => await API.find(`${processo}/pendencias`, id),
  adicionar: async (processo, pendencia) => await API.add(`${processo}/pendencias`, pendencia),
  editar: async (processo, id, pendencia) => await API.edit(`${processo}/pendencias`, id, pendencia),
  atualizar: async (processo, id, obj) => await API.put(`${processo}/pendencias/${id}`, obj),
	transferir: async (processo, id) => await API.put(`${processo}/pendencias/${id}/transferir`),
  excluir: async (processo, id) => await API.remove(`${processo}/pendencias`, id),
  uploadDocumentoTratamento: async (processo, id, arquivo, config) => await axios.post(`${processo}/pendencias/${id}/documentos`, arquivo, config),
  downloadDocumentoTratamento: async (processo, pendencia, id) => await API.download(`${processo}/pendencias/${pendencia}/documentos/${id}`),

  listarStatus: async () => await API.list(`pendencias/status`),
  listarDocumentos: async () => await API.list(`pendencias/documentos`),

  buscarEmail: async (processo, id) => await API.list(`${processo}/pendencias/${id}/email`),
  reenviarEmail: async (processo, id, obj) => await API.add(`${processo}/pendencias/${id}/email`, obj),

  resolverEmLote: async (processo, status, obj) => await API.put(`${processo}/pendencias/status/${status}`, obj),
}

export default PendenciaService;
